var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    {
      attrs: { tabindex: "0" },
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.buscar($event)
        },
      },
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _vm.showSelectorTipoSolucion
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("bandeja.tipoSolucion"),
                                  },
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      on: { change: _vm.changeTipoSolucion },
                                      model: {
                                        value: _vm.tipoSolucionSelect,
                                        callback: function ($$v) {
                                          _vm.tipoSolucionSelect = $$v
                                        },
                                        expression: "tipoSolucionSelect",
                                      },
                                    },
                                    _vm._l(
                                      _vm.tipoSoluciones,
                                      function (itemTipoSolucion, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: {
                                              value: itemTipoSolucion,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  itemTipoSolucion.nombre
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showMostrarConvocatoria ||
                      _vm.siempreMostrarConvocatoria
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    description: _vm.$t(
                                      "bandeja.filtros.descriptionSelectorSolucion"
                                    ),
                                    label: _vm.$t("bandeja.convocatoria"),
                                    "label-for": "select-solucion",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      staticClass: "form-control",
                                      attrs: { id: "select-solucion" },
                                      on: { change: _vm.changeSolucion },
                                      model: {
                                        value: _vm.solucionSelect,
                                        callback: function ($$v) {
                                          _vm.solucionSelect = $$v
                                        },
                                        expression: "solucionSelect",
                                      },
                                    },
                                    _vm._l(
                                      _vm.soluciones,
                                      function (item, index) {
                                        return _c(
                                          "b-form-select-option",
                                          {
                                            key: index,
                                            attrs: { value: item },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.titulo) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorComisiones
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    description: _vm.$t(
                                      "bandeja.filtros.descriptionSelectorComision"
                                    ),
                                    label: _vm.$t("bandeja.tipoComision"),
                                    "label-for": "select-tipo-comision",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "select-tipo-comision",
                                      name: "tipoComision",
                                      options: _vm.tipoComisiones,
                                      disabled: !_vm.solucionSelect,
                                    },
                                    model: {
                                      value: _vm.tipoComisionSelect,
                                      callback: function ($$v) {
                                        _vm.tipoComisionSelect = $$v
                                      },
                                      expression: "tipoComisionSelect",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorAreas
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    description: _vm.$t(
                                      "bandeja.filtros.descriptionSelectorArea"
                                    ),
                                    label: _vm.$t(
                                      "apeironGwApp.insaculacion.area"
                                    ),
                                    "label-for": "select-area",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: { id: "select-area" },
                                      model: {
                                        value: _vm.areaSelect,
                                        callback: function ($$v) {
                                          _vm.areaSelect = $$v
                                        },
                                        expression: "areaSelect",
                                      },
                                    },
                                    _vm._l(_vm.areas, function (item, index) {
                                      return _c(
                                        "b-form-select-option",
                                        { key: index, attrs: { value: item } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.nombre) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorEstadoSolicitud ||
                      _vm.showSelectorTipoSolicitud
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    description:
                                      "Seleccione el tipo de solicitud",
                                    label: "Tipo solicitud",
                                    "label-for": "select-tipo-solicitud",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "select-tipo-solicitud",
                                      name: "tipoSolicitud",
                                      options: _vm.tiposSolicitud,
                                      disabled: !_vm.solucionSelect,
                                    },
                                    model: {
                                      value: _vm.tipoSolicitudSelect,
                                      callback: function ($$v) {
                                        _vm.tipoSolicitudSelect = $$v
                                      },
                                      expression: "tipoSolicitudSelect",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorEvaluacion
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    description: _vm.$t(
                                      "bandeja.filtros.descriptionSelectorEvaluacion"
                                    ),
                                    label: _vm.$t("bandeja.tipoDefinicion"),
                                    "label-for": "select-evaluacion",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      attrs: {
                                        id: "select-evaluacion",
                                        disabled: _vm.disabledSelectEvaluacion,
                                      },
                                      model: {
                                        value: _vm.definicionRevisionSync,
                                        callback: function ($$v) {
                                          _vm.definicionRevisionSync = $$v
                                        },
                                        expression: "definicionRevisionSync",
                                      },
                                    },
                                    _vm._l(
                                      _vm.definicionEvaluacion.revisiones,
                                      function (itemTipoComision, index) {
                                        return _c(
                                          "b-form-select-option",
                                          {
                                            key: index,
                                            attrs: { value: itemTipoComision },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  itemTipoComision.tipoRevision
                                                ) +
                                                " " +
                                                _vm._s(
                                                  itemTipoComision.tipoComision
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorEstadoSolicitud
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    description: _vm.$t(
                                      "apeironGwApp.form.simulation.estadoSolicitud"
                                    ),
                                    label: _vm.$t(
                                      "apeironGwApp.form.simulation.estadoSolicitud"
                                    ),
                                    "label-for": "select-estado-solicitud",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "select-tipo-estado-solicitud",
                                      name: "estadoSolicitud",
                                      options: _vm.estadosSolicitud,
                                      disabled: !_vm.solucionSelect,
                                    },
                                    model: {
                                      value: _vm.estadoSolicitudSync,
                                      callback: function ($$v) {
                                        _vm.estadoSolicitudSync = $$v
                                      },
                                      expression: "estadoSolicitudSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorTipoDocumento
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    description: _vm.$t("documentos.tipoDoc"),
                                    label: _vm.$t("documentos.tipoDoc"),
                                    "label-for": "select-tipo-documento",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "select-tipo-documento",
                                      name: "tipoDocumento",
                                      options: _vm.tiposDocumento,
                                      disabled: !_vm.solucionSelect,
                                    },
                                    model: {
                                      value: _vm.tipoDocumentoSync,
                                      callback: function ($$v) {
                                        _vm.tipoDocumentoSync = $$v
                                      },
                                      expression: "tipoDocumentoSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showMostrarOpcionesAyudantes
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "formalizacion.tipoProcesoAyudantes"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "b-form-select",
                                    {
                                      on: {
                                        change:
                                          _vm.changeTipoProcesoAyudantesSelected,
                                      },
                                      model: {
                                        value: _vm.tipoProcesoAyudantesSelect,
                                        callback: function ($$v) {
                                          _vm.tipoProcesoAyudantesSelect = $$v
                                        },
                                        expression:
                                          "tipoProcesoAyudantesSelect",
                                      },
                                    },
                                    _vm._l(
                                      _vm.tiposProcesoAyudantes,
                                      function (
                                        itemTipoProcesoAyudantes,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: {
                                              value: itemTipoProcesoAyudantes,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  itemTipoProcesoAyudantes.nombre
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorEstadoDocumento
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    description: _vm.$t(
                                      "bandeja.filtros.descriptionSelectorEstadoDocumento"
                                    ),
                                    label: _vm.$t("bandeja.estadoDocumento"),
                                    "label-for": "select-estado-documento",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "select-tipo-estado-documento",
                                      name: "estadoDocumento",
                                      options: _vm.estadosDocumentos,
                                      disabled: !_vm.solucionSelect,
                                    },
                                    model: {
                                      value: _vm.estadoDocumentoSync,
                                      callback: function ($$v) {
                                        _vm.estadoDocumentoSync = $$v
                                      },
                                      expression: "estadoDocumentoSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showInputCvu
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "apeironGwApp.asignacion.placeholder.cvu"
                                    ),
                                    "label-for": "input-cvu",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-cvu",
                                      trim: "",
                                      disabled: _vm.disabledInputCvu,
                                      placeholder: _vm.$t(
                                        "apeironGwApp.asignacion.placeholder.cvu"
                                      ),
                                    },
                                    on: { keypress: _vm.onlyNumbers },
                                    model: {
                                      value: _vm.cvuSync,
                                      callback: function ($$v) {
                                        _vm.cvuSync = $$v
                                      },
                                      expression: "cvuSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showInputSolicitudId
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "formalizacion.numeroSolicitud"
                                    ),
                                    "label-for": "input-solicitud-id",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-solicitud-id",
                                      trim: "",
                                      placeholder: _vm.$t(
                                        "formalizacion.numeroSolicitud"
                                      ),
                                    },
                                    model: {
                                      value: _vm.solicitudIdSync,
                                      callback: function ($$v) {
                                        _vm.solicitudIdSync = $$v
                                      },
                                      expression: "solicitudIdSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showInputCvuInvestigador
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "formalizacion.cvuInvestigador"
                                    ),
                                    "label-for": "input-cvu",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-cvu",
                                      trim: "",
                                      disabled: _vm.disabledInputCvu,
                                      placeholder: _vm.$t(
                                        "formalizacion.cvuInvestigador"
                                      ),
                                    },
                                    on: { keypress: _vm.onlyNumbers },
                                    model: {
                                      value: _vm.cvuSyncInvestigador,
                                      callback: function ($$v) {
                                        _vm.cvuSyncInvestigador = $$v
                                      },
                                      expression: "cvuSyncInvestigador",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showInputCvuEvaluador
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "apeironGwApp.asignacion.placeholder.cvu"
                                    ),
                                    "label-for": "input-cvu",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-cvu",
                                      trim: "",
                                      disabled: _vm.disabledInputCvu,
                                      placeholder: _vm.$t(
                                        "apeironGwApp.asignacion.placeholder.cvuEvaluador"
                                      ),
                                    },
                                    on: { keypress: _vm.onlyNumbers },
                                    model: {
                                      value: _vm.cvuSync,
                                      callback: function ($$v) {
                                        _vm.cvuSync = $$v
                                      },
                                      expression: "cvuSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showInputCorreo
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "apeironGwApp.asignacion.evaluador"
                                    ),
                                    "label-for": "input-correo",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-correo",
                                      trim: "",
                                      disabled: _vm.disabledInputCorreo,
                                      placeholder: _vm.$t(
                                        "apeironGwApp.asignacion.placeholder.evaluador"
                                      ),
                                    },
                                    model: {
                                      value: _vm.correoSync,
                                      callback: function ($$v) {
                                        _vm.correoSync = $$v
                                      },
                                      expression: "correoSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorNivelSni
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("bandeja.nivelSni"),
                                    description: _vm.$t(
                                      "bandeja.filtros.descriptionNoSelectorNivelSni"
                                    ),
                                    "label-for": "select-nivel-sni",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "select-nivel-sni",
                                      name: "nivelSni",
                                      options: _vm.nivelesSni,
                                    },
                                    model: {
                                      value: _vm.nivelSniSync,
                                      callback: function ($$v) {
                                        _vm.nivelSniSync = $$v
                                      },
                                      expression: "nivelSniSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectorTipoVigencia
                        ? _c(
                            "b-col",
                            { attrs: { sm: "12", md: "12", lg: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("bandeja.tipoVigencia"),
                                    description: _vm.$t(
                                      "bandeja.filtros.descriptionSelectorTipoVigencia"
                                    ),
                                    "label-for": "input-tipo-vigencia",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "input-tipo-vigencia",
                                      options: _vm.tiposVigencia,
                                    },
                                    model: {
                                      value: _vm.tipoVigenciaSync,
                                      callback: function ($$v) {
                                        _vm.tipoVigenciaSync = $$v
                                      },
                                      expression: "tipoVigenciaSync",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: { disabled: _vm.disabledButton },
                              on: {
                                click: function ($event) {
                                  return _vm.buscar($event)
                                },
                              },
                            },
                            [
                              _vm._t("botonBuscar", function () {
                                return [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("entity.action.search")) +
                                      "\n              "
                                  ),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }